import React, { useState, useEffect } from 'react';
import {
  Outlet,
  useNavigate
} from "react-router-dom";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Navbar,
  Row
} from 'react-bootstrap';

import useUser from '../hooks/useUser';

import logo from '../images/repcaster_logo_txt.png';
import '../App.css';

export default function Default() {

  const { user } = useUser();

  const navigate = useNavigate();

  useEffect(() => {
    if(user) {
      if (user.user_type === 'customer') navigate("/customer/dashboard");
      if (user.user_type === 'merchant') navigate("/merchant/dashboard");            
    }
  });

  return (
    <Container fluid className="d-flex flex-column g-0">
      <Navbar bg="light" expand="false" className="container-fluid">
        <Container fluid>
          <Col xs={6}>
            <img src={logo} className="landing-logo float-start" alt="logo" />
          </Col>
          <Col xs={6} className="text-end px-2">
            <span></span>
          </Col>
        </Container>
      </Navbar>
      <Container className="pt-3 content-container">
        <Outlet />
      </Container>
      <Container className="mt-auto footer-default">
        <Row className="">
          <Col>
            <small>&copy;{new Date().getFullYear()} Beep. <a href="#">Terms & Conditions</a></small>
          </Col>
        </Row>
      </Container>      
    </Container>
  )
}
